import { Component, OnInit, Input, Output, OnDestroy} from '@angular/core';
import { Location } from '@angular/common';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { TrainingCentersService } from 'projects/services/src/app/API/training-centers.service';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { BatchService } from 'projects/services/src/app/API/batch.service';
import { ToasterService } from 'projects/services/src/app/API/toaster.service';
import { SscUserService } from 'projects/services/src/app/API/ssc-user.service';
import { PmkvycmService } from 'projects/services/src/app/API/pmkvycm.service';
import { PMKVY_TRAINING_TYPES } from 'src/app/scheme-constants/scheme-constants';
import { CurrentUserService } from "projects/services/src/app/current-user.service";
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { TrainingPartnerService } from 'projects/services/src/app/API/training-partner.service';
declare var toastr: any;
declare const swal: any;


@Component({
  selector: 'app-candidate-marksheet',
  templateUrl: './candidate-marksheet.component.html',
  styleUrls: ['./candidate-marksheet.component.css']
})
export class CandidateMarksheetComponent implements OnInit, OnDestroy {
  modelObj = {
    batchId: '',
    canId: '',
    tcId: '',
    batchType:''
  };
  pageNo: any = 1;
  itemsPerPage: any = 10;
  filterObj = {};
  length: any;
  batchDetailsWithBulkInfo:any;
  currentUserData: any;
  batchIdDropDown: any = [];
  candidateIdDropDown: any = [];
  candidateData: any = [];
  tcIdsDropDownData: any = [];
  valid: boolean;
  @Input() mDetails: any;
  isCandidateLoaded: boolean;
  batchType: any;
  regularOldBatchId: any;
  batchMetaData = {
    batchType: '',
    regularOldBatchID: '',
    type: ''

  }
  batchData: any;
  certifiedBatchDate: any;
  assessmentCertKey: any;
  assessmentMode: any;
  showBulkSkillCardButton = false;
  assessmentStatus: any;
  feebaseBatchData: any;
  batchTypeDropDown: string[] = [];
  currentUser: any;
  blockchain: any = false;
  isChangeProfile:boolean=false;
  private Supscriptions = new Subscription()
	updateProfilePhotoForm: FormGroup
  formbuilder: any;
  profileImage:string="";
  isCrntProfilePicUpload:boolean=false;
  currentCandidateId:string="";
  bulkBatchId: any;

  constructor(
    public location: Location,
    private sscUserService: SscUserService,
    private trainingCentreService: TrainingCentersService,
    private fileService: FileService,
    private batchService: BatchService,
    private pmkvycmService: PmkvycmService,
    private batchservice: BatchService,
    private toasterservice: ToasterService,
    private currentUserService: CurrentUserService,
    private activatedRoute: ActivatedRoute,
    private trainingpartnerService: TrainingPartnerService
  ) { }

  ngOnInit() {
    this.currentUserService.getAdditionalInfomartion().subscribe(res => {
      if (res) {
        this.currentUser = res
      }
    })
    this.Supscriptions.add(this.activatedRoute.queryParams.subscribe((queryparmas)=>{
      if(queryparmas.isChangeProfile || queryparmas.isChangeProfile === 'true'){
        this.isChangeProfile = true;
      }
    }))
    if(this.isChangeProfile){
      this.updateProfilePhotoForm = new FormGroup({
        profilePicture: new FormControl("", [Validators.required, ValidationService.fileTypeValidator('jpeg', 'jpg', 'png'),
          ValidationService.fileSizeValidator(5)])
      })
    }
    // this.currentUser = this.currentUserService._currentUser;
    this.assessmentStatus = 'Not self';
    this.currentUserData = this.mDetails;
    console.log(this.currentUserData);
    if (this.currentUserData.role === 'Training Centre') {
      console.log('TC LOGIN');

    this.getBatchIdDropDown();
    }
    if (this.currentUserData.role === 'Training Partner') {
      console.log('TP LOGIN');

      this.getTrainingCentre();
    }
  }
  ngOnDestroy(): void {
    this.Supscriptions.unsubscribe();
  }
  assignPageNo(pageNo) {
		this.pageNo = pageNo;
		this.getCandidate();
		// this.getTrainingCentre();
	}
	assignRecordsPerPage(perPage) {
		this.itemsPerPage = perPage;
		this.getCandidate();
		// this.getTrainingCentre();
	}
  applyFilter() {
		const filter = this.modelObj;
		if (filter.canId) {
			this.filterObj['canId'] = filter.canId || '';
		}
		if (filter.batchId) {

			this.filterObj['batchId'] = filter.batchId || '';
    }
    this.pmkvycmService.getBatchDetailById(this.filterObj['batchId']).subscribe(res => {
      if (res) {
        this.feebaseBatchData = res;
        this.assessmentStatus = res.assessmentMode
        this.batchData = res;
        console.log("$$$$$$$$$$$$$batchDataaaa",this.batchData)
      }
    })
    console.log("-----------------> checking for assessment status", this.assessmentStatus);

    console.log("&&&&&&&&&&&&&&&&&candidateData", this.candidateData);
    this.getCandidate()
  }
  // getCandidate() {
  //   this.candidateData = []
  //   // this.trainingCentreService.getAssessment(this.pageNo, this.itemsPerPage,this.filterObj).subscribe(res => {
  //   //   if (res) {
  //   //     Helpers.copyArray(this.candidateData, res);
  //   //   }
  //   // })
  //   this.trainingCentreService.getAssessmentWithoutPage(this.filterObj).subscribe(res => {
  //     if (res) {
  //       Helpers.copyArray(this.candidateData, res);
  //     }
  //   })
  // }
  getCandidate() {
    this.candidateData = []
    console.log(this.filterObj);
    const filtered = {
      keyword: this.modelObj && this.modelObj.canId ? 'candidateUserName:' + this.modelObj.canId + ',candidateName:' + this.modelObj.canId : '',
      status: '',
      type: '',
      district: '',
      state: '',
      batchStartDate: '',
      batchEndDate: ''
    };
    
   
    

    let payload = {
      candidateId: this.filterObj['canId']
    }
    this.batchService.getCandidateData(payload).subscribe(res => {
      if (res) {
        // this.candidateData = res || 0;
        if (res[0] && res[0].assessmentCertificate) {
          this.assessmentCertKey = res[0].assessmentCertificate
        }
      }
    })
    let batchType = this.modelObj.batchType;
    this.trainingCentreService.getCandidateForMarksheet(this.filterObj, filtered, batchType).subscribe(res => {
      if (res) {
        this.showBulkSkillCard();
        this.batchDetailsWithBulkInfo = res;
        this.certifiedBatchDate = res && res.batchCertified && res.batchCertified.certifiedOn || new Date();
        // this.downloadBulkCertificates=res
        Helpers.copyArray(this.candidateData, res.docs)
      }
    })
  }

  showBulkSkillCard() {
    if (this.batchIdDropDown.length) {
      const batchData = this.batchIdDropDown.find(batch => batch.ids === this.modelObj.batchId);
      /**
      as per requirement
      if (batchData) {
        this.showBulkSkillCardButton = (batchData.trainingType === PMKVY_TRAINING_TYPES.STT.type ||
          batchData.trainingType === PMKVY_TRAINING_TYPES.SP.type) ? false : true;
      }
      **/
      
      if (batchData) {
        this.showBulkSkillCardButton = (batchData.trainingType === PMKVY_TRAINING_TYPES.RPL.type ) ? true : false;
      }
    }
  }

  showIfCanData() {
    if(this.candidateData && this.candidateData.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  getCandidateUserName(canData) {
    if (canData && canData.candidateUserName) {
      return canData.candidateUserName;
    } else {
      return 'N/A';
    }
  }

  getCandidateName(canData) {
    if (canData && canData.candidateName) {
      return canData.candidateName;
    } else {
      return 'N/A';
    }
  }


  getTrainingCentre() {
    this.sscUserService.getTcOfTp(this.currentUserData.userName).subscribe(res => {
      console.log(res);
      const elements = (res && res.data) || [];
      const mapElements = elements.map(element => ({
        ids: element
      }))
      Helpers.copyArray(this.tcIdsDropDownData, mapElements)
    })
  }


  getBatchIdDropDown() {
    this.modelObj.batchId = '';
    if (this.currentUserData.role === 'Training Centre') {
		const projectFields = 'schemeBasicDetails,batchId,schemeObjectId,trackBatch,batchType,regularOldBatchID,type,schemeType';
      this.sscUserService.getBatchIdDropDown(this.currentUserData.userName, projectFields).subscribe(res => {
        this.batchMetaData.batchType = res && res.data && res.data.batchType;
        this.batchMetaData.regularOldBatchID = res && res.data && res.data.regularOldBatchID;
        this.batchMetaData.type = res && res.data && res.data.type;
        console.log('BatchMeta Deta', );
        const elements = (res && res.data) || [];
        const mapElements = elements.map(element => ({
          ids: element.batchId,
          batchType: element.batchType,
          type: element.type,
          trainingType: element.schemeType,
          regularOldBatchID: element.regularOldBatchID,
        }))
        Helpers.copyArray(this.batchIdDropDown, mapElements)
        })
    } else if (this.currentUserData.role === 'Training Partner') {
      console.log(this.modelObj.tcId);
      const projectFields = 'batchId,schemeObjectId,trackBatch,batchType,regularOldBatchID,type,schemeType';
      this.sscUserService.getBatchIdDropDown(this.modelObj.tcId, projectFields).subscribe(res => {
        console.log(res);

        const elements = (res && res.data) || [];
        const mapElements = elements.map(element => ({
          ids: element.batchId,
          batchType: element.batchType,
          type: element.type,
          trainingType: element.schemeType,
          regularOldBatchID: element.regularOldBatchID,
        }))
        Helpers.copyArray(this.batchIdDropDown, mapElements)
        console.log(this.batchIdDropDown);


        })
    }


  }

  showBatchId(batch) {
    if (batch && batch.type === 'pmkvy') {
      if (batch && batch.batchType === 'Reassessment') {
        return batch && batch.regularOldBatchID || 'N/A';
      } else {
        return batch && batch.ids
      }
    } else {
      return batch && batch.ids
    }
  }
  getCandidateDropDown() {
    // if(this)
    // console.log(this.batchIdDropDown);
    this.batchIdDropDown.forEach((item, index, array) => {
      if (this.modelObj.batchId === array[index].ids) {
        console.log(array[index]);
        this.batchMetaData.type = array[index].type;
        this.batchMetaData.regularOldBatchID = array[index].regularOldBatchID;
        this.batchMetaData.batchType = array[index].batchType;
      }
    })
    
    if (this.currentUserData.role !== 'Training Centre') {
      if (this.modelObj.tcId === '') {
        toastr.error('Please select TC ID');
        this.modelObj.batchId = '';
        return;
      }
    }
    this.sscUserService.getCandidateIdDropDownNoPage(this.modelObj.batchId, this.modelObj.batchType).subscribe(res => {
      const elements = (res && res.data) || [];
      const mapElements = elements.map(element => ({
        ids: element.candidateId
      }))
      this.valid = true;
      Helpers.copyArray(this.candidateIdDropDown, mapElements)
    })
  }

  batchIdChanged() {
    this.modelObj.batchType = "";
    this.candidateIdDropDown = [];
    this.sscUserService.getBatchTypeDropDown(this.modelObj.batchId).subscribe((res: any) => {
      this.batchTypeDropDown = res;
    })
  }


  reset() {
    this.modelObj.batchId = '';
    this.modelObj.canId = '';
    this.modelObj.tcId = '';
    this.modelObj.batchType = '';
    if (this.currentUserData.role === 'Training Partner') {
      this.batchIdDropDown = [];
    }
    this.candidateIdDropDown = [];
    this.candidateData = [];
    this.valid = false;
    this.batchTypeDropDown = [];
    this.showBulkSkillCardButton = false;
  }
  getjRole(data) {
    if (data) {
      for (let index = 0; index < data.length; index++){
        return data[index].jobName
      }
    } else {
      return 'N/A'
    }

  }
  downloadCert(candidateData) {
    console.log("@@@@@@@@@downloadcert",candidateData)
    this.pmkvycmService.getBatchDetailById(this.filterObj['batchId']).subscribe(res => {
      if (res) {
        this.assessmentMode = res.assessmentMode
        console.log("1111111111111111candidateData", this.candidateData);
      }
    })
    
    console.log(this.assessmentMode);
    if (this.assessmentMode == 'Self') {
      let payload = {
        userName : candidateData.candidateUserName
      }

      let userdata = {
        candidateId : candidateData.candidateUserName
      }

      //  let payload = {
      //   userName : candidateData.userName
      // }

      // let userdata = {
      //   candidateId : candidateData.userName
      // }
      this.batchService.getCandidateData(userdata).subscribe(res => {
        if (res) {
          if (res[0] && res[0].assessmentCertificate) {
            this.assessmentCertKey = res[0].assessmentCertificate
          }
        }
      })
      if (this.assessmentCertKey == undefined) {
        this.sscUserService.DownloadAssessmentCertificate(payload).subscribe(res => {
          if (res) {
            this.fileService.downloadAttachedFile(res.data[0].value.key)
          }
        })
      } else {
        this.fileService.downloadAttachedFile(this.assessmentCertKey);
      }
     
    } else {
      let result = candidateData && candidateData.assmtCrt && candidateData.assmtCrt.result;
    let attendance = candidateData && candidateData.attendanceStatus;
    // if (!attendance) {
    //   toastr.error('Certificate not available for  Absent candidate');
    //   return;
    // }
    // if (result === null) {
    //   toastr.error('Certificate not available for  failed candidate');
    //   return;
    // }

    if (!attendance && result === null) {
      toastr.error('Certificate not available for Absent candidate');
      return;
    }

    if (attendance && result === 'FAIL') {
      toastr.error('Certificate not available for failed candidate');
      return;
    }

    let doc = candidateData &&  candidateData.certificateDetails && candidateData.certificateDetails.certificateURLDetails && candidateData.certificateDetails.certificateURLDetails.key || ''
      if (candidateData.certificateDetails) {
        this.fileService.downloadAttachedFile(doc)
      } else {
        if (candidateData && candidateData.assmtCrt && candidateData.assmtCrt.result === 'PASS') {
          toastr.error('Certificate has not been generated');
        } else {
          toastr.error('Certificate not available for  failed candidates');
        }
      }
    }
    
  }


  downloadAssessmentCert(candidate) {
    console.log("=========== checking candidate data -----> ", candidate)

    this.trainingpartnerService.getSelectedScheme(this.feebaseBatchData.schemeId,this.currentUser.userName,"","")
    .subscribe((data: any) => {
      data = data || {};
      if (data.schemes) {
        data = data.schemes
      }
      if (data && data.project && data.project.blockchain && data.project.blockchain == true) {
        this.blockchain = true;
      } else {
        this.blockchain = false;
      }
    })
    // if (this.currentUser && this.currentUser.schemes) {
    //   this.currentUser.schemes.forEach(scheme => {
    //     if (this.feebaseBatchData.schemeReferenceId == scheme.schemeReferenceId) {
    //       if (scheme && scheme.project && scheme.project.blockchain && scheme.project.blockchain == true) {
    //         this.blockchain = true;
    //       } else {
    //         // this.blockchain = false;
    //       }
    //     }
    //   })
    // }
    if (this.blockchain == true) {
      toastr.warning('Please Download Bulk Certificates for Blockchain');
    }
    else {
      let payload = {
        userName: candidate.candidateUserName,
        batchId: candidate.batchId
      }

      let userdata = {
        candidateId: candidate.candidateUserName
      }

      this.batchService.getCandidateData(userdata).subscribe(res => {
        if (res) {
          if (res[0] && res[0].assessmentCertificate) {
            this.assessmentCertKey = res[0].assessmentCertificate
          }
          if (res[0] && res[0].assessmentCertificate) {
            this.fileService.downloadAttachedFile(res[0].assessmentCertificate);
        
          } else {
            for (let cert of res[0].batches) {
              if (candidate.batchId == cert.batchId) {
                if (cert && cert.certificateURL && cert.certificateURL) {
                  this.assessmentCertKey = cert.certificateURL.key;
                  this.fileService.downloadAttachedFile(cert.certificateURL);
                } else if (cert && cert.certificationDetails && cert.certificationDetails.certificationURL) { 
                  this.fileService.downloadAttachedFile(cert.certificationDetails.certificationURL)
                } else {
                  this.sscUserService.DownloadAssessmentCertificate(payload).subscribe(res => {
                    if (res) {
                      this.fileService.downloadAttachedFile(res.data[0].value.key)
                    }
                  })
                }
              }
            }
          }
        }
      })
    }
   
  }

  
  downloadMarksheet(candidateData) {
    if (candidateData.markSheetDetails) {
      let doc = candidateData &&  candidateData.markSheetDetails && candidateData.markSheetDetails.markSheetURLDetails && candidateData.markSheetDetails.markSheetURLDetails.key || ''
      this.fileService.downloadAttachedFile(doc)
    } else {
      if (candidateData && candidateData.assmtCrt && candidateData.assmtCrt.result === 'PASS') {
        toastr.error('Masksheet has not been generated');
      } else {
        if (this.batchMetaData && this.batchMetaData.batchType === 'Reassessment') { 
          toastr.error('Marksheet not available');
        } else {
          toastr.error('Marksheet not available for absent candidates');
        }
      }
    }
  }

  generateSkillCard(data) {
    const result = data.jobRoles[0] && data.jobRoles[0].assmtCrt && data.jobRoles[0].assmtCrt.result
    const attendance = data.jobRoles[0] && data.jobRoles[0].attendanceStatus;
    if (!attendance && result === null) {
      toastr.error('Skill Card not available for Absent candidate');
      return;
    }

    if (attendance && result === 'FAIL') {
      toastr.error('Skill Card not available for failed candidate');
      return;
    }
    // if (!attendance && result === null) {
    //   toastr.error('Skill Card Not Available For Absent Candidate');
    //   return;
    // }

    // if(attendance && resu)

    // if (result === 'FAIL') {
    //   toastr.error('Skill Card Not Available For Failed Candidate');
    //   return;
    // }

    // if (!attendance) {
    //   toastr.error('Skill Card Not Available For Absent Candidate');
    //   return;
    // }

    // if (result === null) {
    //   toastr.error('Skill Card Not Available For Failed Candidate');
    //   return
    // }

    
    const sectorName = data && data.jobRoles && data.jobRoles[0] && data.jobRoles[0].sectors && data.jobRoles[0].sectors.sectorID || '';
    const qpCode = data && data.jobRoles && data.jobRoles[0] &&  data.jobRoles[0].qpCode || '';
    const version = data && data.jobRoles && data.jobRoles[0] && data.jobRoles[0].version || '';

    this.sscUserService.genrateSkillCard(data.candidateUserName, data.batchId, sectorName, data.jobRoles[0].jobName, qpCode, version).subscribe(res => {
      this.fileService.downloadAttachedFile(res.skillcard);
    })
  }


  // dowloadassesmentCert(candidate) {
  //   let payload = {
  //     candidateId: candidate.candidateUserName
  //   }
  //   // this.batchService.getCandidateData(payload).subscribe(res => {

  //   // })
  //   let user = {
  //     userName : candidate.candidateUserName 
  //   }
  //   this.sscUserService.DownloadAssessmentCertificate(user).subscribe(res => {
  //     if (res) {
  //       console.log(res);
  //     }
  //   })
  // }

  downloadBulkCertificates(){
    console.log('Download Bulk Certificate API Integration is Pending!', this.batchDetailsWithBulkInfo);
    const bulkUrl = this.batchDetailsWithBulkInfo && this.batchDetailsWithBulkInfo.bulkZipURLDetails && this.batchDetailsWithBulkInfo.bulkZipURLDetails.location;
    if(bulkUrl){
    this.fileService.downloadAttachedFile(bulkUrl)
    }


  }

  downloadBulkSelfCertificates() {
    this.trainingpartnerService.getSelectedScheme(this.feebaseBatchData.schemeId,this.currentUser.userName,"","")
    .subscribe((data: any) => {
      data = data || {};
      if (data.schemes) {
        data = data.schemes
      }
      if (data && data.project && data.project.blockchain && data.project.blockchain == true) {
        this.blockchain = true;
      } else {
        this.blockchain = false;
      }
    })
    // if (this.currentUser && this.currentUser.schemes) {
    //   this.currentUser.schemes.forEach(scheme => {
    //     if (this.feebaseBatchData.schemeReferenceId == scheme.schemeReferenceId) {
    //       if (scheme && scheme.project && scheme.project.blockchain && scheme.project.blockchain == true) {
    //         this.blockchain = true;
    //       } else {
    //         // this.blockchain = false;
    //       }
    //     }
    //   })
    // }

    if (this.blockchain == true) {
      const bulkUrl = this.batchDetailsWithBulkInfo && this.batchDetailsWithBulkInfo.bulkZipURLDetails && this.batchDetailsWithBulkInfo.bulkZipURLDetails.key;
      if (bulkUrl) {
        let payload = {
          _id: this.batchDetailsWithBulkInfo.bulkZipURLDetails.key
        }
        this.batchService.downloadBlockchainZipFile(payload).subscribe(res => {
          if (res) {
            window.open(res.data.data.zipUrl, '_blank')
          }
        })
      }
    } else {
      console.log('Download Bulk Certificate API Integration is Pending!', this.batchDetailsWithBulkInfo);
      const bulkUrl = this.batchDetailsWithBulkInfo && this.batchDetailsWithBulkInfo.bulkZipURLDetails && this.batchDetailsWithBulkInfo.bulkZipURLDetails.location;
      if (bulkUrl) {
        this.fileService.downloadAttachedFile(bulkUrl)
      }
    }
  }

  selfBatchBulkCertificateDownload() {
    let payload = {
      batchId: this.feebaseBatchData.batchId,
      type: "certificate",
      module: "trainingPartner",
      trainingPartnerUserName:  this.feebaseBatchData.tpId,
      trainingCenterUserName: this.feebaseBatchData.tcId
    }
    this.batchService.selfBulkCertificateDownload(payload).subscribe(res => {
      if (res) {
        console.log("=============>self Bulk certificate download API", res);
        toastr.success('Request submitted successfully');
      }
    })
  }
  getAttendance(candidate) {
    if (candidate.jobRoles && candidate.jobRoles[0]) {
      if (this.batchMetaData && this.batchMetaData.batchType === 'Reassessment') {
        const candidateAttendanceStatus = candidate && candidate.jobRoles &&  candidate.jobRoles[0] && candidate.jobRoles[0].attendanceStatus;
        if (this.certifiedBatchDate !== new Date().toISOString()) {
          if (candidateAttendanceStatus === null) {
            return 'Awaiting For Attendance';
          } else if (candidateAttendanceStatus === true) {
            return 'Present';
          } else if (candidateAttendanceStatus === false) {
            return 'Absent'
           }

        }
      } else {
        const candidateAttendanceStatus = candidate && candidate.jobRoles &&  candidate.jobRoles[0] && candidate.jobRoles[0].attendanceStatus;
        if (candidateAttendanceStatus === null) {
          return 'Awaiting For Attendance';
        } else if (candidateAttendanceStatus === true) {
          return 'Present';
        } else if (candidateAttendanceStatus === false) {
          return 'Absent'
         }
      }
    }

  }

  getResult(candidate) {
    if (candidate.jobRoles && candidate.jobRoles[0]) {
      if (candidate.jobRoles[0] && candidate.jobRoles[0].assmtCrt && candidate.jobRoles[0].assmtCrt.result) {
          return candidate.jobRoles[0].assmtCrt.result
      } else {
        return 'N/A'
      }
    }
  }

  downloadBulkSkillCard() {
    if (this.batchDetailsWithBulkInfo && this.batchDetailsWithBulkInfo.isSkillCardAvailable === 'Y') {
      const bulkUrl = this.batchDetailsWithBulkInfo && this.batchDetailsWithBulkInfo.skillCardAwsPath;
      this.fileService.downloadAttachedFile(bulkUrl);
    } else {
      toastr.error('Bulk Skill Card Not Yet Generated');
    }
  }

  downloadInsuranceCard(url) {
    if (url !== '' && url !== undefined && url !== null) {
      let doc = url || ''
      this.fileService.getImageURL(doc).subscribe((res) => {
        	window.open(res);
        });
    } else {
      toastr.error('Insurance Card has not been generated');
    }
  }


  downloadBulkInsuranceCard() {
    let data = this.batchData;
    if ((data.trackBatch === "BATCH_ASSMT_RESULT_ASSESSMENT_DONE" || data.trackBatch === "BATCH_ASSMT_RESULT_SSC_ACCEPTED") && (data.type === "pmkvy" || data.type === "msde") && (data.schemeName === "PMKVY-3.0-CSCM" || data.schemeName === "MoHUA - Ministry of Housing and Urban Affairs")) { 
      if (this.batchDetailsWithBulkInfo && this.batchDetailsWithBulkInfo.insuranceCardBulkUrl !== '' && this.batchDetailsWithBulkInfo.insuranceCardBulkUrl !== undefined && this.batchDetailsWithBulkInfo.insuranceCardBulkUrl !== null) {
        const bulkUrl = this.batchDetailsWithBulkInfo && this.batchDetailsWithBulkInfo.insuranceCardBulkUrl;
        this.fileService.getImageURL(bulkUrl).subscribe((res) => {
          window.open(res);
        });
      } else {
        this.batchservice.generateBulkInsuranceCard(`batchId=${data.batchId}&bulkRequest=true`).subscribe(res => {
          console.log(res);
          if (res && res.bulkInsuranceCardUrl) {
            let url = res.bulkInsuranceCardUrl;
            this.fileService.getImageURL(url).subscribe((res) => {
              window.open(res);
            });
          }
        })
      }
    } else {
			this.toasterservice.showWarningToaster('You dont have permission to generate insurance card for this batch');
		}
  }

  GenerateInsuranceCard(batch) {
		this.batchservice.generateBulkInsuranceCard(`batchId=${batch.batchId}&candidateId=${batch.candidateUserName}&bulkRequest=false`).subscribe(res => {
			if (res && res.insuranceCard) {
				// swal(
				// 	`Insurance Card Successfully Generated`,
				// 	`For Candidate - ${batch.candidateUserName}`,
				// 	"success"
				// );
        this.downloadInsuranceCard(res.insuranceCard)
			} else {
				swal(
					`Failed to download Insurance card`,
					"warning"
				);
			}
		})
	}
  // batchTypeChanged() {
  //   if (this.modelObj.batchType !== "") {
  //     this.valid = true;
  //   }
  // }

  updateProfilePhoto(candId) {
		this.currentCandidateId = candId
		this.updateProfilePhotoForm.reset();
		Helpers.openModal('profilePhoto');
	}

  fileUploaded(event) {
		if (event) {
			const role = 'Candidate';
			this.fileService.getImageURL(event, role).subscribe(res => {
				this.profileImage = res;
        this.isCrntProfilePicUpload = true;
				this.updateProfilePhotoForm.get('profilePicture').setValue(event);
			})
		} else {
			this.isCrntProfilePicUpload = false;

		}
	}

  onFileUploadCancel(event, uploaded: string) {
		this.updateProfilePhotoForm.get('profilePicture').setValue('');
	}

  submitProfilePhoto() {
		if (this.updateProfilePhotoForm.invalid) {
			Helpers.markFormGroupTouched(this.updateProfilePhotoForm);
			return;
		}
		if (this.updateProfilePhotoForm.valid) {
			swal({
				title: 'Are you sure want to update the Profile Photo?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Yes'
			}).then(result => {
				if (result.value) {
					const mapPayLoad = this.updateProfilePhotoForm.value;
					mapPayLoad['candidateId'] = this.currentCandidateId;
          mapPayLoad['batchId'] = Number(this.modelObj.batchId);
					this.batchService.updateCandidateProfilePhoto(mapPayLoad,'yes').subscribe(res => {
						this.isCrntProfilePicUpload = false;
						toastr.success('Profile Photo Updated Successfully!!')
						Helpers.closeModal('profilePhoto');
            this.applyFilter();
					})
				}
			});
		} else {
			toastr.error('Please fill all mandatory details')
		}
	}
  // openCandidateProfilePhotoModal(){
  //   Helpers.openModal('profilePhoto');
  // }
  closeCanProfilePhotoModel(){
    this.profileImage = '';
    Helpers.closeModal('profilePhoto');
  }
  reGenerateCertificate(canId){
    console.log("----------Regenrate certificate----------");
    this.batchService.regenerateCertBasedOnBatchIdAndCanId(Number(this.modelObj.batchId),canId).subscribe((res)=>{
      if(res.statusCode === 200 && res.status === 'success'){
        toastr.success("The certificate re-generated successfully!");
        this.applyFilter();
      }
    },(err)=>{
      toastr.error("Something went wrong!");
      console.log(err.message);
    })
  }
}
